module.exports = __webpack_public_path__ + "static/media/heating-dark-gray.98272491.svg";